/* eslint-disable */
import { useEffect, useRef, useState } from 'react'
import RoundButton from '../../../framework/forms/helpercomponents/buttons/RoundButton';
import * as API from '../../../framework/API/api';
import { ENTITYNAME } from '../../../framework/constant/constant';
import { useTranslation } from '../../../locale/useTranslation';
import { toast } from 'react-toastify';
import { ConfirmDeleteAlert } from '../../../ConfirmAlert';
import { utility } from '../../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../../components/EditPageHeader';
import NodeEditForm from '../../masters/NodeEditForm';
import { ContextMenu } from 'primereact/contextmenu';

const NodeTreeViewForm = (props) => {

    const { height, handleSelectedNodes, isMultiSelect = false, isSaveButton = false, onClose, selectedNodeIds = [] } = props;

    const lang = useTranslation();

    const [treeData, setTreeData] = useState([]);
    const [expandedNodes, setExpandedNodes] = useState(new Set());
    const [hashNodes, setHashNodes] = useState([]);
    const [selectedNode, setSelectedNode] = useState({});
    const [selectedNodes, setSelectedNodes] = useState([]);
    const [showNodeModal, setShowNodeModal] = useState({
        show: false,
        isEdit: false
    });
    const cm = useRef();

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        try {
            setSelectedNode({});
            let nodeRes = await API.getDataLookup(ENTITYNAME.Nodes, { query: ["Archive", "!=", true] });
            let nodeData = nodeRes?.data || [];
            if (selectedNodeIds?.length == 0) {
                setHashNodes(nodeData);
                const tree = buildTreeStructure(nodeData);
                setTreeData(tree);
                return;
            }
            let selectedVodNodesChild = new Set([]);
            const searchChild = (parent) => {
                nodeData?.forEach(n => {
                    if (n?.ParentNode == parent._id) {
                        selectedVodNodesChild.add(n);
                        searchChild(n);
                    }
                });
            }
            let selectedVodNodes = nodeData?.filter(n => selectedNodeIds.includes(n._id));
            selectedVodNodes?.forEach(n => {
                searchChild(n);
            })
            const nodesArray = [...selectedVodNodesChild];
            setHashNodes(nodesArray);
            const tree = buildTreeStructure(nodesArray);
            setTreeData(tree);
        } catch (error) {
            console.error('Error loading nodes:', error);
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>{'Error loading nodes:' + error}</div>
                </div>
            );
        }
    };

    const buildTreeStructure = (nodeData) => {
        const nodeMap = new Map();

        nodeData.forEach(n => {
            nodeMap.set(n._id, {
                ...n,
                children: []
            });
        });
    
        const catalogueMap = new Map();
        nodeData.forEach(n => {
            const catId = n?.Catalogue?._id;
            if (!catalogueMap.has(catId)) {
                catalogueMap.set(catId, {
                    _id: catId,
                    Name: n?.Catalogue?.Description,
                    nodes: [],
                    isCatalogue: true,
                });
            }
            catalogueMap.get(catId).nodes.push(n._id);
        });
    
        const CatalogueRoots = [];
    
        catalogueMap.forEach(cat => {
            const rootNodes = [];
    
            cat.nodes.forEach(id => {
                const node = nodeMap.get(id);
    
                if (node.ParentNode) {
                    const parentNode = nodeMap.get(node.ParentNode);
                    if (parentNode) {
                        parentNode.children.push(node);
                    } else {
                        rootNodes.push(node);
                    }
                } else {
                    rootNodes.push(node);
                }
            });
    
            const sortTree = (nodes) => {
                // nodes.sort((a, b) => a.Name.localeCompare(b.Name));
                nodes.forEach(n => sortTree(n.children));
            };
    
            sortTree(rootNodes);
    
            CatalogueRoots.push({_id: cat._id,Name: cat.Name,children: rootNodes,isCatalogue: true});
            
        });
    
        // CatalogueRoots.sort((a, b) => a.Name.localeCompare(b.Name));
    
        return CatalogueRoots;
    };

    const toggleNode = (node) => {
        setExpandedNodes(prev => {
            const newSet = new Set(prev);
            if (newSet.has(node._id)) {
                newSet.delete(node._id);
                if(node.isCatalogue) {
                    setSelectedNode({});
                    setSelectedNodes([]);
                    handleSelectedNodes && handleSelectedNodes({});
                }
            } else {
                newSet.add(node._id);
            }
            return newSet;
        });
    };

    const getAllDescendantIds = (node) => {
        let ids = [node._id];
        if (node.children && node.children.length > 0) {
            node.children.forEach(child => {
                ids = [...ids, ...getAllDescendantIds(child)];
            });
        }
        return ids;
    };

    const isNodeSelected = (nodeId) => {
        if (isMultiSelect) {
            return selectedNodes.some(cat => cat._id === nodeId);
        } else {
            return selectedNode?._id === nodeId;
        }
    };

    const contextMenuCancel = () => {
        setSelectedNode({});
        setSelectedNodes([]);
        handleSelectedNodes && handleSelectedNodes({});
    };

    const renderTreeNode = (nodeValue, level = 0) => {
        const hasChildren = nodeValue.children && nodeValue.children.length > 0;
        const isExpanded = expandedNodes.has(nodeValue._id);
        const isSelected = isNodeSelected(nodeValue._id);
        const isHidden = nodeValue?.isHidden;

        let nodeIcon = hasChildren ? (isExpanded ? '▼' : '▶') : '•';
        let nodeLabel = nodeValue.Name;

        const handleIconClick = (e) => {
            e.stopPropagation();
            if (hasChildren) {
                toggleNode(nodeValue);
            }
        };

        const handleLabelClick = async (e) => {
            e.stopPropagation();
            if(nodeValue.isCatalogue) {
                setSelectedNode({});
                setSelectedNodes([]);
                handleSelectedNodes && handleSelectedNodes({});
                return;
            }
            if (isMultiSelect) {
                const isAlreadySelected = selectedNodes.some(n => n._id === nodeValue._id);

                let updatedSelection;
                if (isAlreadySelected) {
                    updatedSelection = selectedNodes.filter(
                        n => !nodeValue._id.includes(n._id)
                    );
                } else {
                    updatedSelection = [...selectedNodes, nodeValue];
                }
                setSelectedNode(updatedSelection?.length > 0 ? updatedSelection[0] : {});
                setSelectedNodes(updatedSelection);
            } else {
                setSelectedNode(nodeValue);
                handleSelectedNodes && handleSelectedNodes(nodeValue);
            }
        };

        return (
            <div key={nodeValue._id}>
                <div
                    className="tree-node"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 8px 8px ' + (level * 20 + 8) + 'px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee',
                        backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                        transition: 'background-color 0.2s'
                    }}
                    onClick={handleLabelClick}
                    onMouseEnter={(e) => {
                        if (!isSelected) e.currentTarget.style.backgroundColor = '#f5f5f5';
                    }}
                    onMouseLeave={(e) => {
                        if (!isSelected) e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    onContextMenu={(e) => {
                        e.preventDefault();
                        if (nodeValue.isCatalogue) return;
                        if (Object.keys(selectedNode).length == 0 && !isMultiSelect) {
                            toast.error(
                                <div>
                                    <strong>INVALID</strong>
                                    <div style={{ fontSize: '13px' }}>{lang.please_select_atleast_one_item}</div>
                                </div>,
                                { position: toast.POSITION.TOP_RIGHT }
                            );
                            return;
                        }
                        if (Object.keys(selectedNode).length > 0) {
                            setSelectedNode(nodeValue);
                            cm.current.show(e);
                        }
                    }}
                >
                    <span
                        style={{
                            marginRight: '8px',
                            fontWeight: hasChildren ? 'bold' : 'normal',
                            minWidth: '10px',
                            cursor: hasChildren ? 'pointer' : 'default'
                        }}
                        onClick={handleIconClick}
                    >
                        {nodeIcon}
                    </span>
                    <span
                        style={{
                            fontWeight: isSelected ? 'bold' : 'normal',
                            flex: 1,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '6px',
                        }}
                    >
                        {nodeLabel}

                        {!nodeValue.isCatalogue && (
                            <i
                                className={`pi ${isHidden ? 'pi-eye-slash' : 'pi-eye'}`}
                                style={{
                                    fontSize: '12px',
                                    color: isHidden ? '#f44336' : '#4caf50'
                                }}
                                title={isHidden ? 'Hidden' : 'Visible'}
                            />
                        )}
                    </span>
                </div>

                {hasChildren && isExpanded && (
                    <div className="tree-children">
                        {nodeValue.children.map(child => renderTreeNode(child, level + 1))}
                    </div>
                )}
            </div>
        );
    };

    const onDeleteContentCategory = async () => {
        let res = await API.onDeleteContentCategory({ id: selectedNode?._id });
        if (res.success) {
            utility.deleteLocalStorageItem(ENTITYNAME.ContentCategory);
            toast.success(res.message);
            loadCombo();
            setSelectedNode({});
            handleSelectedNodes && handleSelectedNodes({});
        } else {
            toast.error(res.message);
        }
    }

    const onCancel = () => {
        setSelectedNode({});
        setSelectedNodes([]);
        onClose && onClose();
    }

    const handleSubmit = () => {
        let finalData = hashNodes.filter(n => selectedNodes.some(selectedNode => selectedNode._id === n._id));
        handleSelectedNodes && handleSelectedNodes(finalData);
        onCancel();
    }

    const handleHideUnhideNode = async (node, isHidden) => {
        try {
            const updatedNode = { ...node, isHidden: isHidden };

            const res = await API.saveData(ENTITYNAME.Nodes, { _id: node._id, isHidden: isHidden });

            if (res?.success) {
                toast.success(
                    <div>
                        <strong>SUCCESS</strong>
                        <div style={{ fontSize: '13px' }}>
                            {isHidden ? lang.node_hidden_success_message : lang.node_show_success_message}
                        </div>
                    </div>,
                    { position: toast.POSITION.TOP_RIGHT }
                );

                let localStorageData = utility.getValue(ENTITYNAME.Nodes);
                const updatedData = localStorageData?.data?.map(n => n._id === updatedNode._id ? updatedNode : n);
                utility.setValue(ENTITYNAME.Nodes, updatedData);
                // Update treeData to reflect change in UI
                const updateTreeNode = (nodes) => {
                    return nodes.map(n => {
                        if (n._id === updatedNode._id) {
                            return updatedNode;
                        } else if (n.children) {
                            return { ...n, children: updateTreeNode(n.children) };
                        } else {
                            return n;
                        }
                    });
                };

                setTreeData(prevTree => updateTreeNode(prevTree));
                setSelectedNode(updatedNode);
                contextMenuCancel();
            }
        } catch (error) {
            console.error(error);
            toast.error(isHidden ? lang.node_hidden_error_message : lang.node_show_error_message);
        }
    };

    return (
        <>
            {isSaveButton && <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={onCancel} saveButtonTitle={lang.select_button_text} />}
            <div className="tree-view-wrapper" style={{
                border: '1px solid #ddd',
                backgroundColor: '#fff',
                borderRadius: '4px',
                maxHeight: 'calc(100vh - 150px)',
                height: height ?? 'auto',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    margin: '0',
                    fontSize: '15px',
                    borderBottom: '2px solid #ddd',
                    padding: '10px 10px 10px 10px',
                    fontWeight: 'bold',
                    backgroundColor: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexShrink: 0
                }}>
                    <span>
                        <span style={{ marginRight: '5px', fontSize: '10px' }}>📋 </span>
                        {lang.nodes_label}
                        {isMultiSelect && selectedNodes.length > 0 && (
                            <span style={{ marginLeft: '10px', fontSize: '12px', color: '#2196F3' }}>
                                ({selectedNodes.length} selected)
                            </span>
                        )}
                    </span>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <RoundButton
                            icon="plus"
                            onClick={() => setShowNodeModal({ show: true, isEdit: false })}
                            title={lang.add_content_category_label}
                        />
                        {((selectedNode?._id || selectedNodes.length === 1) && !selectedNode?.isCatalogue) && <>
                        <RoundButton
                            icon="edit"
                            onClick={() => setShowNodeModal({ show: true, isEdit: true })}
                            title={lang.edit_content_category_label}
                        />
                            <RoundButton
                                icon="trash"
                                onClick={() => ConfirmDeleteAlert(() => onDeleteContentCategory(), () => { })}
                                title={lang.delete_content_category_label}
                            /></>}
                    </div>
                </div>

                <div className="tree-view-container" style={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    padding: '10px',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#888 #f1f1f1'
                }}>
                    <style>
                        {`
                    .tree-view-container::-webkit-scrollbar {
                        width: 8px;
                    }
                    .tree-view-container::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 4px;
                    }
                    .tree-view-container::-webkit-scrollbar-thumb {
                        background: #888;
                        border-radius: 4px;
                    }
                    .tree-view-container::-webkit-scrollbar-thumb:hover {
                        background: #555;
                    }
                `}
                    </style>
                    {treeData.length > 0 ? (
                        treeData.map(node => renderTreeNode(node))
                    ) : (
                        <p style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
                            {lang.no_nodes_found_message}
                        </p>
                    )}
                </div>
            </div>
            <ContextMenu
                ref={cm}
                model={[
                    !selectedNode?.isHidden && {
                        label: lang.hide_node_label,
                        icon: "pi pi-fw pi-eye-slash",
                        command: () => handleHideUnhideNode(selectedNode, true),
                    },
                    selectedNode?.isHidden && {
                        label: lang.show_node_label,
                        icon: "pi pi-fw pi-eye",
                        command: () => handleHideUnhideNode(selectedNode, false),
                    },
                    {
                        label: lang.ref_cancel_label,
                        icon: "pi pi-fw pi-times",
                        command: contextMenuCancel,
                    }
                ].filter(Boolean)}
            />

            {showNodeModal.show && <NodeEditForm item={showNodeModal.isEdit ? selectedNode : { parentNode: selectedNode?._id, Catalogue: selectedNode?.Catalogue }} cancelEdit={() => setShowNodeModal(false)} refresh={loadCombo} />}
        </>
    )
}

export default NodeTreeViewForm;
